import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M22,6H20a2.006,2.006,0,0,0-2-2H16.82a2.988,2.988,0,0,0-5.64,0H10A2.006,2.006,0,0,0,8,6H6A2.006,2.006,0,0,0,4,8V28a2.006,2.006,0,0,0,2,2h4V28H6V8H8a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2h2v2h2V8A2.006,2.006,0,0,0,22,6ZM18,8H10V6h3V5a1,1,0,0,1,2,0V6h3Z"/><path d="M26,12H14a2.006,2.006,0,0,0-2,2V28a2.006,2.006,0,0,0,2,2H26a2.006,2.006,0,0,0,2-2V14A2.006,2.006,0,0,0,26,12Zm0,16H14V14H26Z"/><path d="M24,21a1,1,0,0,1-1,1H17a1,1,0,0,1,0-2h6A1,1,0,0,1,24,21Z"/><path d="M24,17a1,1,0,0,1-1,1H17a1,1,0,0,1,0-2h6A1,1,0,0,1,24,17Z"/>';
export var PasteOutlineSVG = function PasteOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PasteOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PasteOutlineSVG);